import header from "./happy-couple-making-deal.jpg";
import section1 from "./unterschreiben-des-vertrags.jpg";
import section2 from "./portrait-smiling-real-estate-agent.jpg";
import section3 from "./besprechung-der-rahmenbedingungen.jpg";
import section4 from "./man-is-working-laptop-with-icons-screen.jpg";
import section5 from "./couple-communicating-with-insurance-agent.jpg";
import section6 from "./happy-insurance-agent-shaking-hands.jpg";
import section7 from "./man-signs-apartment-purchase-contract.jpg";
import section8 from "./ohniedlung-von-oben.jpg";
import section9 from "./young-adult-organizing-documents.jpg";
import section10 from "./woman-dressed-formally-office-writing.jpg";
import section11 from "./contract-female-partner-meeting.jpg";
import section12 from "./besichtigungen.jpg";
import section13 from "./happy-real-estate-agent-having-meeting.webp";
import section14 from "./closeup-shot-person-holding-tablet.jpg";
import section15 from "./young-renters-couple-renting-apartment.jpg";
import section16 from "./schluesseluebergabe.jpg";
import section17 from "./smiling-real-estate-agent.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
  section11,
  section12,
  section13,
  section14,
  section15,
  section16,
  section17,
};
